import { createSelector } from '@reduxjs/toolkit';

// Models
import { IDashboardState } from './dashboard.slice';
import { TRootState } from '../index';

/**
 A selector function to retrieve the dashboard data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {IDashboardState} The dashboard state object from the Redux store
 */
const selectDashboardState = (state: TRootState): IDashboardState => state.dashboard;

/**
 A memoized selector function to retrieve the dashboard data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, IDashboardState, (res: IDashboardState) => IDashboardState>}
 */
export const getDashboardState = createSelector(
  [selectDashboardState],
  (state): IDashboardState => state
);
